import { RealisationHourtype } from '../../app/classes/realisation';
import { Environment, PeriodType } from '../../app/environment';
import { entityTypes } from './entitytypes';
import { Roles } from './roles';
import { PlanningStatus } from './status.planning';
import { VkmStatus } from './status.vkm';

export const envBasics: Environment = {
    appTitle: 'Planning DvdS',
    dirkAppUrl: 'http://localhost:4200/',
    asphaltexecutor: Roles.Asphaltexecutor,
    allowWorksWith: false,
    apiEndpoint: '',
    asphaltPlanning: true,
    checkHoursBundle: 'afas_project_id',
    companyAddress: {
        street: 'Floridadreef',
        housenumber: '19',
        zipcode: '3565 AM',
        town: 'Utrecht',
    },
    dayReportPlanning: true,
    dayReportCollapsedNamesLimit: 3,
    defaultStand: true,
    disableAfas: true,
    employeeEmployees: false,
    employeePlanning: true,
    enableDayreport: false,
    entitytypes: entityTypes,
    entitytypeTemplates: null,
    executor: Roles.Executor,
    executorName: 'uitvoerder',
    executorNamePlural: 'uitvoerders',
    executorPlanning: true,
    executors: [Roles.Executor, Roles.Asphaltexecutor],
    feEndpoint: 'http://localhost:4204/',
    fromEmail: 'planning@dvds.nl',
    inventarizePlanning: false,
    leaveHourTypes: [
        { value: RealisationHourtype.frost, label: 'Vorst' },
        { value: RealisationHourtype.time_for_time, label: 'Tijd voor tijd' },
        { value: RealisationHourtype.paid_leave, label: 'Doorbetaald verlof' },
        { value: RealisationHourtype.short_absence, label: 'Kort verzuim' },
        { value: RealisationHourtype.education, label: 'Scholing' },
        { value: RealisationHourtype.bank_holiday, label: 'Feestdag' },
        { value: RealisationHourtype.special_leave, label: 'Bijzonder verlof' },
        { value: RealisationHourtype.additional_parental, label: 'Aanv. geb verl. + ouderschapsv' },
    ],
    limitFutureOwnPlanningOverview: true,
    microsoftLogin: true,
    microsoftLoginRequired: true,
    name: 'D van der Steen B.V.',
    officePhoneNumber: '+31639777701',
    onlyAddRealisationOnPlanning: false,
    onlyOvertime: true,
    orderDirect: false,
    periodType: PeriodType.FourWeeks,
    periodSettlementColums: {
        '135V': true,
        '145V': true,
        '200V': false,
        100: true,
        125: true,
        135: true,
        145: true,
        150: false,
        200: false,
        '200Z': false,
        Z: true,
    },
    planningEntityTypes: [],
    planningTableDialog: 'dvds',
    platform: 'dvds',
    production: false,
    projectIdentifier: /\b(\d{4}(-\d{1,4})?)\b/,
    projectmanager: Roles.Projectmanager,
    // Public, unauthenticated "melding indienen" (KAM) form is a DvdS-wide intake point:
    // general/company-wide reports always come in via DvdS, so only enabled here, not per subsidiary (e.g. TL).
    publicTicketForm: true,
    realisationHourTypes: [
        { value: RealisationHourtype.driving_back, label: 'Transporttijd' },
        { value: RealisationHourtype.worktime, label: 'Werktijd' },
        { value: RealisationHourtype.travel_back, label: 'Reistijd' },
        { value: RealisationHourtype.frost, label: 'Spaaruren' },
        { value: RealisationHourtype.paid_leave, label: 'Doorbetaald verlof' },
        { value: RealisationHourtype.short_absence, label: 'Kort verzuim' },
        { value: RealisationHourtype.sleep, label: 'Slapen' },
        { value: RealisationHourtype.special_leave, label: 'Bijzonder verlof' },
        { value: RealisationHourtype.education, label: 'Scholing' },
    ],
    roles: {
        AiReports: Roles.AiReports,
        Asphalt: Roles.Asphalt,
        Asphaltcoordinator: Roles.Asphaltcoordinator,
        Asphaltexecutor: Roles.Asphaltexecutor,
        Codalt: Roles.Codalt,
        CompactMachinist: Roles.CompactMachinist,
        Construction: Roles.Construction,
        Employee: Roles.Employee,
        Executor: Roles.Executor,
        Executors: Roles.Executors,
        FormerEmployee: Roles.FormerEmployee,
        Hourcheck: Roles.Hourcheck,
        HourCheckRestricted: Roles.HourCheckRestricted,
        HoursExtended: Roles.HoursExtended,
        Hourwriter: Roles.Hourwriter,
        Hrm: Roles.Hrm,
        Kam: Roles.Kam,
        Leave: Roles.Leave,
        LeaveManagement: Roles.LeaveManagement,
        Machinist: Roles.Machinist,
        Management: Roles.Management,
        Planner: Roles.Planner,
        PlanningAlwaysRead: Roles.PlanningAlwaysRead,
        ProjectManagement: Roles.ProjectManagement,
        Projectmanager: Roles.Projectmanager,
        StreetGroundTraffic: Roles.StreetGroundTraffic,
        Supplier: Roles.Supplier,
        Traffic: Roles.Traffic,
        TruckDriver: Roles.TruckDriver,
        UserManagement: Roles.UserManagement,
        Uta: Roles.Uta,
        VkmExecutor: Roles.VkmExecutor,
        VkmMechanic: Roles.VkmMechanic,
    } as const,
    rootPage: 'asfaltplanning',
    rootPageName: 'Asfaltplanning',
    shortName: 'DvdS',
    status: {
        Planning: {
            PlanningBakVanWessel: PlanningStatus.PlanningBakVanWessel,
            PlanningDefinitief: PlanningStatus.PlanningDefinitief,
            PlanningGeblokkeerd: PlanningStatus.PlanningGeblokkeerd,
            PlanningGepland: PlanningStatus.PlanningGepland,
            PlanningReservering: PlanningStatus.PlanningReservering,
            PlanningSlaapdag: PlanningStatus.PlanningSlaapdag,
        },
        Vkm: {
            VkmGepland: VkmStatus.VkmGepland,
            VkmAfgerekend: VkmStatus.VkmAfgerekend,
        },
    } as const,
    test: false,
    titleAppend: ' - D. van der Steen B.V.',
    transportPlanning: true,
    travelTime: true,
    vkmPlanning: true,
    weekPlanning: false,
    weekPlanningEmployees: [],
    wsEndpoint: 'ws://localhost:1340',
    weekScheduleComponent: 'realisations',
};
